<script lang="ts">
    import { fly } from "svelte/transition";
    import gsap from "gsap";

    export let num: number;
    export let subline: string;
    export let bgcolor: string = "var(--grayLight)";
    export let size: string = "16rem";
    const pulsing = () => {
        if (pulse == null) return;
        gsap.set(pulse, {
            scale: 1,
            opacity: 1,
        });
        gsap.to(pulse, {
            scale: 1.5,
            opacity: 0,
        });
        // console.log(num.toLocaleString());
    };
    $: num, pulsing();

    let pulse: HTMLElement;
    let circle: HTMLElement;
</script>

<div bind:this={circle} class="circle" style="--bgcolor: {bgcolor}; --size: {size}">
    <div class="number">
        {num.toLocaleString()}
    </div>
    <div class="subline">
        {subline}
    </div>
    <div class="pulse" bind:this={pulse} />
</div>

<style lang="scss">
    @import "./src/vars";

    .pulse {
        opacity: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 1000px;
        border: 2px solid $yellow;
        top: 0;
        left: 0;
        z-index: -2;
    }

    .circle {
        position: relative;
        z-index: 0;
        border-radius: 1000px;
        border: 3px solid $yellow;
        width: 100%;
        font-size: 12em;
        max-width: 1em;
        background-color: var(--bgcolor);
        margin: 0.25em 0.55em;
        @media (max-width: 1500px) {
        }
        * {
            font-family: "Lato";
        }
        &::before {
            content: "";
            width: 100%;
            display: block;
            padding-top: 100%;
        }
        .number,
        .subline {
            position: absolute;
            left: 50%;
            top: 40%;
            transform: translate(-50%, -50%);
            display: block;
            width: auto;
            font-weight: 900;
        }
        .number {
            color: white;
            font-size: 0.33em;
            text-shadow: 0 0.05em 0.125em rgba(black, 0.125);
            background-color: var(--bgcolor);
            min-width: 110%;
            text-align: center;
        }
        .subline {
            color: $yellow;
            font-size: 0.125em;
            top: 75%;
        }
    }
</style>
